<div class="auth-container">
  <!-- Registered, waiting on the email. Shown INSTEAD of the form, so the
       person is not left looking at a sign-up form they have already
       completed. This screen NEVER says the address is verified: it has not
       been, until they open the link, and the account cannot sign in before
       then. "Your email is verified" belongs to /verify-email alone. -->
  <mat-card class="auth-card" *ngIf="success">
    <mat-card-header>
      <mat-card-title>Check your email</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div style="padding:24px 8px; text-align:center;">
        <mat-icon color="primary" style="font-size:56px;width:56px;height:56px;">mark_email_unread</mat-icon>
        <h2>Almost there</h2>
        <p>We have sent a verification link to your email address. Open it to
           activate your account — you cannot sign in until you do.</p>
        <p style="color:#666;font-size:.9em;">No email after a few minutes? Check your spam folder.</p>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="auth-card" *ngIf="!success">
    <mat-card-header>
      <mat-card-title>Create Account</mat-card-title>
      <mat-card-subtitle>Register as a Customer</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="submit()">

        <div class="row">
          <mat-form-field appearance="outline" class="half-width">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="firstName" autocomplete="given-name">
            <mat-error *ngIf="form.get('firstName')?.hasError('required')">Required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="half-width">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="lastName" autocomplete="family-name">
            <mat-error *ngIf="form.get('lastName')?.hasError('required')">Required</mat-error>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" autocomplete="email">
          <mat-icon matSuffix>email</mat-icon>
          <mat-error *ngIf="form.get('email')?.hasError('required')">Email is required</mat-error>
          <mat-error *ngIf="form.get('email')?.hasError('email')">Enter a valid email</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Phone (optional)</mat-label>
          <input matInput type="tel" formControlName="phone" autocomplete="tel">
          <mat-icon matSuffix>phone</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="new-password">
          <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-hint>Minimum 8 characters</mat-hint>
          <mat-error *ngIf="form.get('password')?.hasError('required')">Password is required</mat-error>
          <mat-error *ngIf="form.get('password')?.hasError('minlength')">Minimum 8 characters</mat-error>
        </mat-form-field>

        <button mat-raised-button color="primary" type="submit" class="full-width submit-btn" [disabled]="loading || success">
          <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
          <span *ngIf="!loading">Create Account</span>
        </button>

      </form>
    </mat-card-content>

    <mat-card-actions>
      <p class="auth-link">
        Already have an account? <a routerLink="/login">Sign In</a>
      </p>
      <p class="auth-link">
        Are you a bar owner? <a routerLink="/register-bar">Register your Bar</a>
      </p>
    </mat-card-actions>
  </mat-card>
</div>

<style>
  .auth-container { display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f5f5f5; padding: 24px; }
  .auth-card { width: 100%; max-width: 480px; padding: 24px; }
  .full-width { width: 100%; margin-bottom: 16px; }
  .row { display: flex; gap: 16px; }
  .half-width { flex: 1; margin-bottom: 16px; }
  .submit-btn { height: 48px; margin-top: 8px; }
  .auth-link { text-align: center; font-size: 14px; color: #666; margin-top: 8px; }
  .auth-link a { color: #1976d2; text-decoration: none; font-weight: 500; }
  .auth-link a:hover { text-decoration: underline; }
  mat-card-title { font-size: 24px; font-weight: 700; }
</style>
